export const setVisibilityFilter = filter => ({
  type: 'SET_VISIBILITY_FILTER',
  filter
});

export const removeVisibilityFilter = filter => ({
  type: 'REMOVE_VISIBILITY_FILTER',
  filter
});


// WEBPACK FOOTER //
// ./src/actions/DataDefaultActions.js